import axiosInstance from './axiosInstance'
import { ApiResponse, Notification, PagedResponse } from '../types'

export const notificationApi = {
  getNotifications: (page = 0, size = 20) =>
    axiosInstance.get<ApiResponse<PagedResponse<Notification>>>(
      `/notifications?page=${page}&size=${size}`
    ),

  getUnreadCount: () =>
    axiosInstance.get<ApiResponse<{ count: number }>>('/notifications/unread-count'),

  markRead: (id: number) =>
    axiosInstance.post<ApiResponse<void>>(`/notifications/mark-read/${id}`),

  markAllRead: () =>
    axiosInstance.post<ApiResponse<void>>('/notifications/mark-all-read'),

  saveFcmToken: (fcmToken: string, deviceType: 'WEB' | 'ANDROID' | 'IOS') =>
    axiosInstance.post<ApiResponse<void>>('/notifications/fcm-token', { fcmToken, deviceType }),

  deleteFcmToken: (token: string) =>
    axiosInstance.delete<ApiResponse<void>>(`/notifications/fcm-token?token=${token}`),
}
